module.exports = __webpack_public_path__ + "img/265.7b5f93a9.png";